<h1 mat-dialog-title
	style="padding-left: 8px; padding-top:4px"
	i18n="@@export-notification-dialog.title">
	Achtung
</h1>

<mat-dialog-content i18n="@@export-notification-dialog.content">
	<p>
		Falls der Download von Windows blockiert wird, bitte «erlauben» oder «herunterladen» auswählen
	</p>
</mat-dialog-content>

<mat-dialog-actions class="elohn-dialog-actions">
	<button mat-raised-button
			color="primary"
			[mat-dialog-close]="true"
			i18n="@@global.close">Schliessen
	</button>
</mat-dialog-actions>